export default {
  relationship: {
    title: "Payments and packs relation",
    linkForm: {
      modal: {
        title: "Payment and pack relation"
      },
      form: {
        cardPayment: {
          header: "Payment"
        },
        cardPack: {
          header: "Pack"
        },
        codefirme: {
          title: "Organization"
        },
        datebank: {
          title: "Bank date"
        },
        datepay: {
          title: "Payment date"
        },
        summa: {
          title: "Total"
        },
        sumprof: {
          title: "For services"
        },
        status: {
          title: "Payment total includes commission fee"
        },
        quantity: {
          title: "Receipts"
        },
        countband: {
          title: "Parcels"
        },
        difference: {
          title: "Difference between payment and pack ammounts"
        },
        userid: {
          title: "Assigned operator"
        }
      }
    },
    searchErrorPaymentsForm: {
      modal: {
        title: "Search for an erroneous payment"
      },
      form: {
        abcode: "Personal account",
        sumPay: "Payment amount",
        dateBank: "Date by bank",
        datePay: "Date of payment",
        dateChange: "Date of change",
        and: "and",
        errorType: "Error type",
        npack: "Pack number",
        datePayFrom: "Payment period from",
        datePayTo: "to",
        kindpay: "Payment type",
        codefirme: "Payer",
        note: "Note"
      },
      extendedSearch: "F2 - Advanced Search",
      confirm: {
        searchTermNotSpecified: "Search term not specified. Show all payments?",
        veryMuchPayments:
          "There can be a lot of such payments and their loading can take a long time. Are you sure you want to see all such payments?"
      }
    },
    errorPaymentsForm: {
      modal: {
        title: "Correcting and posting erroneous payments"
      },
      autoDistribute: "F2 - Post payment automatically after change"
    },
    paymentsRelationColumn: {
      headers: {
        paymentsRelation: "Payments"
      }
    },
    packsRelationColumn: {
      headers: {
        packsRelation: "Packs"
      }
    },
    packsInternetRelationColumn: {
      headers: {
        packsInternetRelation: "Internet packs"
      }
    },
    linkConfirm: {
      title: "Payment and pack relation",
      linkPayment: "Connect payment",
      for: "for",
      from: "from",
      inAmount: "for the amount",
      withRecPay: "with the received payments",
      pcs: "pcs",
      attention:
        "Attention! Payment and pack data differ. Do you want to connect them anyway?"
    },
    linkResultTitle: "Result"
  }
};
